import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCaratUp = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m12 9.75 4.25 5.5h-8.5z"
    />
  </svg>
);
export default SvgCaratUp;
